<div class="question-type__text">
  <h1 class="fs__xxl">Multi Choice</h1>
  <p class="fs__md">Participants can select multiple answers from a predefined list. Best for cases where more than one option may apply.</p>
  <h2 class="fs__lg">Example</h2>
  <p class="fs__md">Which of the following sports do you watch?</p>
  <ul class="question-type__bullet-points">
    <li class="fs__sm">
      <span class="text fw__500">Soccer</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Hurling</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Rugby</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Gaelic Football</span>
    </li>
  </ul>
</div>
